import React  from "react";
import { useParams } from 'react-router-dom';
import FarmForm from "./components/FarmForm";
import AccountHeader from "../components/AccountHeader";

const EditFarm = () => {
	const { accountId, farmId } = useParams();

	return (
	    <div>
	      	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<AccountHeader className="mt-5"/>
				<FarmForm recordId={farmId} accountId={accountId} mode="edit"/>
			</div>
	    </div>
    );
};

export default EditFarm;